import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect, useCallback } from 'react';
import { Box } from '../../../Box';
import { Button } from '../../../Button';
import { CounterBadge } from '../../../CounterBadge';
import { Dropdown } from '../../../Dropdown';
import { Flex } from '../../../Flex';
import { Menu } from '../../../Menu';
import { Spacer } from '../../../Spacer';
import { Typography } from '../../../Typography';
import { ActionMenuItem } from '../../styled';
import { ElementEdge, useElementEdgeInView } from './hooks/useElementEdgeInView';
import { useElementPosition } from './hooks/useElementPosition';
import { StyledDropdownBtn, StyledActionBarContainer } from './styled';

var ActionBar = function ActionBar(_ref) {
  var nonVerticallyScrollingParent = _ref.nonVerticallyScrollingParent,
      actions = _ref.actions,
      selectedRows = _ref.selectedRows,
      verticalScrollingParent = _ref.verticalScrollingParent,
      _ref$cancelBtnText = _ref.cancelBtnText,
      cancelBtnText = _ref$cancelBtnText === void 0 ? 'Cancel' : _ref$cancelBtnText,
      _ref$selectedItemsTex = _ref.selectedItemsText,
      selectedItemsText = _ref$selectedItemsTex === void 0 ? 'selected items' : _ref$selectedItemsTex,
      onCancel = _ref.onCancel,
      onStickyChange = _ref.onStickyChange;
  var elementBottomEdgeInView = useElementEdgeInView(ElementEdge.Bottom, nonVerticallyScrollingParent.current, verticalScrollingParent.current);

  var _useElementPosition = useElementPosition(nonVerticallyScrollingParent.current),
      left = _useElementPosition.left,
      width = _useElementPosition.width;

  var styleProps = _extends({}, elementBottomEdgeInView === false ? {
    left: left,
    width: width
  } : {});

  var renderSecondActionIfNeeded = useCallback(function () {
    if (actions && Array.isArray(actions) && actions.length === 2) {
      var secondAction = actions[1];
      var ActionRenderer = secondAction.renderer;
      return ActionRenderer ? /*#__PURE__*/React.createElement(ActionRenderer, {
        rowsData: selectedRows
      }) : /*#__PURE__*/React.createElement(Button, {
        size: "small",
        mode: "outline",
        onClick: function onClick() {
          return secondAction.onExecute(selectedRows);
        }
      }, secondAction.label);
    }

    return null;
  }, [actions, selectedRows]);
  var renderFirstActionIfNeeded = useCallback(function () {
    if (actions && Array.isArray(actions) && actions.length <= 2) {
      var firstAction = actions[0];
      var ActionRenderer = firstAction.renderer;
      return ActionRenderer ? /*#__PURE__*/React.createElement(ActionRenderer, {
        rowsData: selectedRows
      }) : /*#__PURE__*/React.createElement(Button, {
        mode: "fill",
        size: "small",
        onClick: function onClick() {
          return firstAction.onExecute(selectedRows);
        }
      }, firstAction.label);
    }

    return null;
  }, [actions, selectedRows]);
  var renderMultipleActionsIfNeeded = useCallback(function () {
    return actions && (Array.isArray(actions) && actions.length > 2 || typeof actions === 'function') && /*#__PURE__*/React.createElement(Box, {
      marginLeft: "s"
    }, typeof actions === 'function' ? actions(selectedRows) : /*#__PURE__*/React.createElement(Dropdown, {
      trigger: /*#__PURE__*/React.createElement(StyledDropdownBtn, {
        color: 'green'
      }, "Actions"),
      anchor: "end"
    }, /*#__PURE__*/React.createElement(Menu, null, actions.map(function (action) {
      var ActionRenderer = action.renderer;
      return ActionRenderer ? /*#__PURE__*/React.createElement(ActionRenderer, {
        key: action.label,
        rowsData: selectedRows
      }) : /*#__PURE__*/React.createElement(ActionMenuItem, {
        key: action.label,
        onClick: function onClick() {
          return action.onExecute(selectedRows);
        }
      }, /*#__PURE__*/React.createElement(Typography, null, action.label));
    }))));
  }, [actions, selectedRows]);
  useEffect(function () {
    onStickyChange == null ? void 0 : onStickyChange(!!elementBottomEdgeInView);
  }, [elementBottomEdgeInView, onStickyChange]);
  return /*#__PURE__*/React.createElement(StyledActionBarContainer, _extends({
    elementBottomEdgeInView: !!elementBottomEdgeInView
  }, styleProps), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(CounterBadge, {
    count: Object.keys(selectedRows).length,
    size: "large",
    backgroundColor: "primary.base"
  }), /*#__PURE__*/React.createElement(Typography, {
    marginLeft: "xxs",
    color: "black"
  }, selectedItemsText)), /*#__PURE__*/React.createElement(Spacer, {
    space: "s",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "black",
    mode: "link",
    onClick: onCancel
  }, cancelBtnText), /*#__PURE__*/React.createElement(Spacer, {
    space: "s",
    alignItems: "center"
  }, renderSecondActionIfNeeded(), renderFirstActionIfNeeded(), renderMultipleActionsIfNeeded())));
};

export { ActionBar };